import { useTranslation } from 'react-i18next';
import { SpeakerIcon } from '@/components/icons/SpeakerIcon.tsx';
import { useProjectStore } from '@/store/projectStore.ts';
import { useUiStore } from '@/store/uiStore.ts';
import styles from './AudioGutterButton.module.css';

export function AudioGutterButton() {
  const { t } = useTranslation('audioWorkspace');
  const project = useProjectStore(s => s.project);
  const readOnly = useProjectStore(s => s.readOnly);
  const audioWorkspaceOpen = useUiStore(s => s.audioWorkspaceOpen);
  const isRecording = useUiStore(s => s.isRecording);
  const openAudioWorkspace = useUiStore(s => s.openAudioWorkspace);
  const closeAudioWorkspace = useUiStore(s => s.closeAudioWorkspace);

  const setTeaseOverlay = useUiStore(s => s.setTeaseOverlay);
  const disabled = !readOnly && !project;

  const handleClick = () => {
    if (readOnly) { setTeaseOverlay('audio'); return; }
    audioWorkspaceOpen ? closeAudioWorkspace() : openAudioWorkspace();
  };

  return (
    <div className={styles.wrapper}>
      <button
        className={`${styles.btn} ${audioWorkspaceOpen ? styles.btnActive : ''} ${isRecording ? styles.btnRecording : ''}`}
        onClick={handleClick}
        disabled={disabled}
        title={t('audioWorkspaceTooltip')}
      >
        <SpeakerIcon />
        <span className={styles.label}>{t('gutterLabel')}</span>
      </button>
    </div>
  );
}
